import React from 'react';
import { useTranslation } from 'react-i18next';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { computeDeltaDisplay } from '../../utils/reportDelta';

/**
 * Story 21-B — compact inline "vs last month" indicator for a table cell (as opposed to
 * ReportMetricTile's full card). Same delta rules (utils/reportDelta) as the 21-A tiles, just
 * without the trailing "vs last month" label — the column header/context already implies it.
 */
function DeltaBadge({ metric, coloring = 'neutral' }) {
  const { t } = useTranslation('reports');
  const { hasDelta, deltaClass, direction, absPercent } = computeDeltaDisplay(metric, coloring);
  const DeltaIcon = direction === 'up' ? TrendingUp : direction === 'down' ? TrendingDown : null;

  return (
    <span className={`inline-flex items-center gap-0.5 text-xs font-medium ${deltaClass}`}>
      {DeltaIcon && <DeltaIcon size={11} />}
      {hasDelta ? `${absPercent.toFixed(1)}%` : t('summary.noDelta')}
    </span>
  );
}

export default DeltaBadge;
